document.addEventListener("DOMContentLoaded", function () {
  // Tab switching logic
  const tabButtons = document.querySelectorAll(".faq-tabs__tab-button");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const sectionId = this.getAttribute("data-section-id");
      const tabId = this.getAttribute("data-tab");

      // Remove active class from all buttons in this section
      document
        .querySelectorAll(
          `[data-section-id="${sectionId}"].faq-tabs__tab-button`
        )
        .forEach((btn) => {
          btn.classList.remove("active");
        });

      // Add active class to clicked button
      this.classList.add("active");

      // Hide all tab content in this section
      document
        .querySelectorAll(`[data-section-id="${sectionId}"][data-tab-content]`)
        .forEach((content) => {
          content.classList.add("tw:hidden");
          content.classList.remove("tw:block");
        });

      // Show the selected tab content
      const targetContent = document.querySelector(
        `[data-section-id="${sectionId}"][data-tab-content="${tabId}"]`
      );
      if (targetContent) {
        targetContent.classList.remove("tw:hidden");
        targetContent.classList.add("tw:block");
      }
    });
  });

  // FAQ accordion logic
  const faqHeaders = document.querySelectorAll(".faq-item__header");
  const PADDING_OFFSET = 20;

  faqHeaders.forEach((faqHeader) => {
    //    add click listener to accordion tab
    faqHeader.addEventListener("click", function () {
      const faqItem = faqHeader.closest(".faq-item");
      const contentWrapper = faqItem.querySelector(
        ".faq-item__content"
      );
      const isOpen = faqHeader.getAttribute("aria-expanded") === "true";
      const contentHeight = faqItem.querySelector(
        ".faq-item__answer"
      ).scrollHeight + PADDING_OFFSET;
      isOpen
        ? (contentWrapper.style.height = "0px")
        : (contentWrapper.style.height = contentHeight + "px");
      faqHeader.setAttribute("aria-expanded", !isOpen);
    });
  });

});